// /admin/sales — sales report, attribution links, revenue share models and payouts.
import { lazyRoute } from "aldoo-ra/Router/lazy-route"
import { vendorRole } from "../AdminShared/vendor-role"

export default {
  "/admin/sales*": lazyRoute(() => import("./index"), vendorRole),
}
